// form1
// UserDetails.js (formerly UserForm.js)
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal"; // Bootstrap modal
import Button from "react-bootstrap/Button";
import UserDetails from "./DetailForm"; // Adjust if using UserDetails instead

function UserForm({ onNext, updateState, formData }) {
  const [formFields, setFormFields] = useState(formData);
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showInstruction, setShowInstruction] = useState(true);

  useEffect(() => {
    // No storage check — just show once on initial render
    setShowInstruction(true);
  }, []);
  
  

  useEffect(() => {
    setFormFields((prevFields) => ({
      ...prevFields,
      ...formData,
    }));
  }, [formData]);

  useEffect(() => {
    setTimeout(() => {
      const inputs = document.querySelectorAll("input");
      const autofilled = {};
  
      inputs.forEach((input) => {
        if (input.name && input.value) {
          // console.log("Autofilled", input.name, input.value);
          autofilled[input.name] = input.value;
        }
      });
  
      setFormFields((prev) => {
        const updated = {
          ...prev,
          ...autofilled,
        };
        updateState(updated);
        return updated;
      });
    }, 100); // Wait 100ms to let browser autofill settle
  }, []);
  

//   // Handle browser autofill
//  useEffect(() => {
//   const inputs = document.querySelectorAll('input');
//   const autofilled = {};

//   inputs.forEach((input) => {
//     if (input.name && input.value) {
//       autofilled[input.name] = input.value;
//     }
//   });

//   setFormFields((prev) => ({
//     ...prev,
//     ...autofilled,
//   }));

//   updateState({
//     ...formFields,
//     ...autofilled,
//   });
// }, []);


  const handleInputChange = (field) => (e) => {
    const value = e.target.value;
    const updatedFields = {
      ...formFields,
      [field]: value,
    };
    setFormFields(updatedFields);
    updateState(updatedFields);
  };

  const requiredFields = [
    { field: "name", label: "Name" },
    { field: "address", label: "Address" },
    { field: "mobile_no", label: "Mobile Number" },
    { field: "email", label: "Email Address" },
    { field: "qualification", label: "Qualification" },
    { field: "school_university_name", label: "School/University" },
    { field: "course_year", label: "Course/Year" },
    { field: "present_occupation", label: "Present Occupation" },
   
  
  ];

  const handleNext = () => {
    let hasErrors = false;
    const newErrors = {};
    requiredFields.forEach(({ field, label }) => {
      if (!formFields[field]) {
        hasErrors = true;
        newErrors[field] = `${label} is required.`;
      }
    });
    if (hasErrors) {
      setErrors(newErrors);
    } else {
      setErrors({});
      setShowModal(true);
    }
  };

  const handleModalConfirm = () => {
    setShowModal(false);
    if (typeof onNext === "function") {
      onNext(formFields); // ✅ Proceed to next step or redirect
    }
  };

  return (
    <div className="container-fluid">
      <div id="msform">
        <fieldset>
          <h2 className="fs-titleh">
            Expression of Effect for Opening a School{" "}
          </h2>
          <h2 className="fs-title">
          1. Personal Information
          </h2>
          {/* <h3 className="fs-subtitle">1. Personal Information </h3> */}
          {/* form Start  */}
          <div className="row">
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <label className="left-text">
                Name <span className="required-asterisk">*</span>
                <input
                  className="inp"
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Only allow alphabetic characters (no numbers)
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleInputChange("name")(e);
                    }
                  }}
                  value={formFields?.name}
                  name="name"
                  required
                  placeholder="Name *"
                />
                {errors.name && <p className="error-message">{errors.name}</p>}{" "}
              </label>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <label className="left-text">
                Mobile Number <span className="required-asterisk">*</span>
                <input
                  className="inp"
                  type="number"
                  // onChange={handleInputChange('mobile_no')}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only 10 digits
                    if (/^\d{0,10}$/.test(value)) {
                      handleInputChange("mobile_no")(e);
                    }
                  }}
                  value={formFields?.mobile_no}
                  name="mobile_no"
                  onBlur={(e) => {
                    const value = e.target.value;
                    // Check if the input is at least 10 digits
                  }}
                  maxLength="10" // Ensures max length is 10
                  placeholder="1 - Mobile number *"
                />
                {errors.mobile_no && (
                  <p className="error-message" style={{ color: "red" }}>
                    {errors.mobile_no}
                  </p>
                )}
              </label>
            </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                <label className="left-text">
                  Email <span className="required-asterisk">*</span>
                  <input
                    className="inp"
                    type="text"
                    // onChange={handleInputChange('email')}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only 10 digits
                      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        handleInputChange("email")(e);
                      }
                    }}
                    value={formFields?.email}
                    name="email_address"
                    placeholder="Email Address *"
                  />
                  {errors.email && (
                    <p className="error-message" style={{ color: "red" }}>
                      {errors.email}
                    </p>
                  )}
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                <label className="left-text">
                  Partner Name
                  <input
                    className="inp"
                    type="text"
                    //onChange={handleInputChange('partner_name')}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow alphabetic characters (no numbers)
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        handleInputChange("partner_name")(e);
                      }
                    }}
                    value={formFields?.partner_name}
                    name="name_two_partner"
                    required
                    placeholder="Name in case of two partners"
                  />
                </label>
              </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Partner Mobile Number
              <input
                className="inp"
                type="number"
                // onChange={handleInputChange('mobile_no_2')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only 10 digits
                  if (/^\d{0,10}$/.test(value)) {
                    handleInputChange("mobile_no_2")(e);
                  }
                }}
                maxLength="10" // Ensures max length is 10
                value={formFields?.mobile_no_2}
                name="mobile_number_2"
                onBlur={(e) => {
                  const value = e.target.value;
                }}
                placeholder="2 - Mobile number"
              />
              </label>
            </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <label className="left-text">
              Partner Email
                <input
                  className="inp"
                  type="text"
                  //onChange={handleInputChange('partner_email')}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only 10 digits
                    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                      handleInputChange("partner_email")(e);
                    }
                  }}
                  value={formFields?.partner_email}
                  name="email_address_two_partners"
                  placeholder="Email Address in case of two partners"
                />
                </label>
              </div>
            </div>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <label className="left-text">
                Address <span className="required-asterisk">*</span>
                <input
                  className="inp"
                  type="text"
                  onChange={handleInputChange("address")}
                  value={formFields?.address}
                  required
                  name="address"
                  placeholder="Address *"
                />
                {errors.address && (
                  <p className="error-message" style={{ color: "red" }}>
                    {errors.address}
                  </p>
                )}
              </label>
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Partner Address
              <input
                className="inp"
                type="text"
                onChange={handleInputChange("partner_address")}
                value={formFields?.partner_address}
                name="address_two_partner"
                placeholder="Address in case of two partners"
              />
              </label>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
              <label className="left-text">
              WhatsApp Number
              <input
                  className="inp"
                  type="text"
                  onChange={(e) => {
                    console.log("whatsapp_no input change:", e.target.value); // for debug
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      handleInputChange("whatsapp_no")(e);
                    }
                  }}
                  value={formFields?.whatsapp_no}
                  name="whatsapp_no"
                  placeholder="WhatsApp No"
                  maxLength="10"
                />
                {errors.whatsapp_no && (
                  <p className="error-message" style={{ color: "red" }}>
                    {errors.whatsapp_no}
                  </p>
                )}

                </label>
            </div>
          </div>

          {/* <h3 className="fs-subtitle">2. Education</h3> */}
          <h2 className="fs-title">
           2. Qualification | School/University | Course/Year of Completion
          </h2>
          <br/>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Qualification <span className="required-asterisk">*</span>
              <input
                className="inp"
                type="text"
                onChange={handleInputChange("qualification")}
                value={formFields?.qualification}
                name="qualification"
                placeholder="Enter your qualification *"
              />
              </label>
              {errors.qualification && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.qualification}
                </p>
              )}
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            School/University <span className="required-asterisk">*</span>
              <input
                className="inp"
                type="text"
                onChange={handleInputChange("school_university_name")}
                value={formFields?.school_university_name}
                name="school_university"
                placeholder="Enter school/university"
              />
              </label>

              {errors.school_university_name && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.school_university_name}
                </p>
              )}
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Course Year <span className="required-asterisk">*</span>

              <input
                className="inp"
                type="text"
                onChange={handleInputChange("course_year")}
                value={formFields?.course_year}
                name="course_year"
                placeholder="Enter course/year of completion *"
              />
              </label>
              {errors.course_year && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.course_year}
                </p>
              )}
            </div>
          </div>

          <h3 className="fs-title">3. Business / Professional Details</h3>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Occupation <span className="required-asterisk">*</span>
              <input
                className="inp"
                type="text"
                //onChange={handleInputChange('present_occupation')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow alphabetic characters (no numbers)
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange("present_occupation")(e);
                  }
                }}
                value={formFields?.present_occupation}
                name="occupation"
                placeholder="Enter your present occupation *"
              />
              </label>
              {errors.present_occupation && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.present_occupation}
                </p>
              )}
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Company Name <span className="required-asterisk">*</span>
              <input
                className="inp"
                type="text"
                // onChange={handleInputChange('company_name')}

                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow alphabetic characters (no numbers)
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange("company_name")(e);
                  }
                }}
                value={formFields?.company_name}
                name="company_name"
                placeholder="Enter company name *"
              />
              </label>
              {errors.company_name && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.company_name}
                </p>
              )}
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
             DIN Number <span className="required-asterisk"></span>
              <input
                className="inp"
                type="text"
                //onChange={handleInputChange('din_number')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only 10 digits
                  if (/^\d{0,30}$/.test(value)) {
                    handleInputChange("din_number")(e);
                  }
                }}
                value={formFields?.din_number}
                name="din_number"
                placeholder="Enter DIN number *"
                maxLength="30" // Ensures max length is 30
              />
              </label>
              
            </div>
          </div>

          <div className="row">
          

            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
           Company Functional Years
              <input
                className="inp"
                type="text"
                onChange={handleInputChange("company_functional_year")}
                value={formFields?.company_functional_year}
                name="years_functional"
                placeholder="Enter number of years"
              />
              </label>
              {errors.company_functional_year && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.company_functional_year}
                </p>
              )}
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            office address
              <input
                className="inp"
                type="text"
                onChange={handleInputChange("office_address")}
                value={formFields?.office_address}
                name="office_address"
                placeholder="Enter office address"
              />
              </label>
              {/* {errors.office_address && <p className="error-message" style={{ color: 'red' }}>{errors.office_address}</p>} */}
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
            <label className="left-text">
            Office Mobile Number
              <input
                className="inp"
                type="text"
                onChange={handleInputChange("office_contact_number")}
                value={formFields?.office_contact_number}
                name="contact_details"
                placeholder="Enter contact details"
              />
              </label>
              {errors.office_contact_number && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.office_contact_number}
                </p>
              )}
            </div>
            </div>

         
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-3">
            <label className="left-text">
            Reference Name 1
              <input
                className="inp"
                type="text"
                // onChange={handleInputChange('reference_name_1')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow alphabetic characters (no numbers)
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange("reference_name_1")(e);
                  }
                }}
                value={formFields?.reference_name_1}
                name="reference_1"
                placeholder="Enter reference 1"
              />
              </label>
              {errors.reference_name_1 && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.reference_name_1}
                </p>
              )}
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-3">
            <label className="left-text">
            Reference Number 1
              <input
                className="inp"
                type="text"
                // onChange={handleInputChange('reference_number_1')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only 10 digits
                  if (/^\d{0,10}$/.test(value)) {
                    handleInputChange("reference_number_1")(e);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  // Check if the input is at least 10 digits
                  // if (value.length < 10) {
                  // alert("Mobile number must be exactly 10 digits.");
                  // }
                }}
                maxLength="10" // Ensures max length is 10
                value={formFields?.reference_number_1}
                name="reference_2"
                placeholder="Enter reference 1 Mobile Number"
              />
              </label>
              {errors.reference_number_1 && (
                <p className="error-message" style={{ color: "red" }}>
                  {errors.reference_number_1}
                </p>
              )}
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-3">
              
            <label className="left-text">
            Reference Name 2
              <input
                className="inp"
                type="text"
                // onChange={handleInputChange('reference_name_2')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow alphabetic characters (no numbers)
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleInputChange("reference_name_2")(e);
                  }
                }}
                value={formFields?.reference_name_2}
                name="reference_2"
                placeholder="Enter reference 2"
              />
              </label>
            </div>
           
            <div className="col-12 col-sm-12 col-md-6 col-lg-3">
            <label className="left-text">
            Reference Number
              <input
                className="inp"
                type="text"
                //onChange={handleInputChange('reference_number_2')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only 10 digits
                  if (/^\d{0,10}$/.test(value)) {
                    handleInputChange("reference_number_2")(e);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  // Check if the input is at least 10 digits
                  // if (value.length < 10) {
                  //   alert("Mobile number must be exactly 10 digits.");
                  // }
                }}
                maxLength="10" // Ensures max length is 10
                value={formFields?.reference_number_2}
                name="reference_2"
                placeholder="Enter reference 2 Mobile Number"
              />
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-12">
            <label className="left-text">
            WhatsApp Number
              <input
                className="inp"
                type="url"
                onChange={handleInputChange("company_website_name")}
                value={formFields?.company_website_name}
                name="company_website"
                pattern="https?://.+"
                placeholder="Company Website (if any)"
              />
              </label>
            </div>
          </div>

          <button
            type="button"
            className="next action-button"
            onClick={handleNext}
          >
            Next
          </button>
        </fieldset>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header>
          {/* <Modal.Title>Confirm </Modal.Title> */}

          <Modal.Title className="mb-0">Confirm Submission</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body>
          All fields have been filled. Do you want to proceed to the next step
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            style={{
              border: "none",
              background: "#eabb1b",
              borderRadius: "25px",
              marginRight: "10px",
              padding: "10px 20px",
              fontWeight: "bold",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleModalConfirm}
            style={{
              borderRadius: "25px",
              background: "#174d82",
              padding: "10px 17px",
              fontWeight: "bold",
            }}
          >
            Yes, Continue
          </Button>
        </Modal.Footer>
      </Modal>
  {/* ✅ Confirm Submission Modal */}
<Modal show={showModal} onHide={() => setShowModal(false)} centered>
  <Modal.Header>
    <Modal.Title className="mb-0">Confirm Submission</Modal.Title>
    <button
      type="button"
      className="btn-close"
      aria-label="Close"
      onClick={() => setShowModal(false)}
    ></button>
  </Modal.Header>
  <Modal.Body>
    All fields have been filled. Do you want to proceed to the next step?
  </Modal.Body>
  <Modal.Footer className="d-flex justify-content-center">
    <Button
      variant="secondary"
      onClick={() => setShowModal(false)}
      style={{
        border: "none",
        background: "#eabb1b",
        borderRadius: "25px",
        marginRight: "10px",
        padding: "10px 20px",
        fontWeight: "bold",
      }}
    >
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={handleModalConfirm}
      style={{
        borderRadius: "25px",
        background: "#174d82",
        padding: "10px 17px",
        fontWeight: "bold",
      }}
    >
      Yes, Continue
    </Button>
  </Modal.Footer>
</Modal>

{/* ✅ Instruction Modal */}
<Modal
  show={showInstruction}
  onHide={() => setShowInstruction(false)}
  centered
  backdrop="static"
  className="mb-0"
>
  <Modal.Header
    style={{ backgroundColor: "#174d82", color: "white", borderBottom: "none" }}
  >
    <Modal.Title style={{ fontWeight: "bold" }}>
      📘 Important Instructions
    </Modal.Title>
  </Modal.Header>

  <Modal.Body
    style={{
      fontSize: "15px",
      lineHeight: "1.6",
      backgroundColor: "#f7f9fc",
      color: "#333",
      padding: "25px"
    }}
  >
    <p>
      <strong>Kindly fill in the form carefully.</strong> Fields having{" "}
      <span style={{ color: "red", fontWeight: "bold" }}>*</span> are mandatory to fill.
    </p>
    <p>
      Please be ready with the <strong>softcopy of the following documents</strong>:
    </p>
    <ul style={{ paddingLeft: "20px", marginBottom: 0 }}>
      <li>📷 Photograph of the Authorized Signatory</li>
      <li>🪪 ID Proof - <strong>PAN CARD / AADHAR CARD</strong></li>
      <li>📄 Letter Head of the Trust / Society / Company U/s 8</li>
      <li>📜 Trust Deed / Society Registration / Certificate of Incorporation</li>
      <li>🧾 PAN Card of the Society / Trust / Company</li>
      <li>📌 Board Resolution Copy</li>
      <li>📑 Land Papers / Lease Deed</li>
      <li>🗺️ Site Map</li>
      <li>🏢 Floor-wise Architectural Drawings</li>
      <li>🚒 Fire NOC, Land Conversion Approval</li>
      <li>📊 Last 3 Years ITR of Society / Trust / Company</li>
    </ul>
  </Modal.Body>

  <Modal.Footer style={{ backgroundColor: "#f7f9fc", borderTop: "none" }}>
    <Button
      variant="secondary"
      onClick={() => setShowInstruction(false)}
      style={{
        border: "none",
        background: "#eabb1b",
        borderRadius: "25px",
        marginRight: "10px",
        padding: "10px 20px",
        fontWeight: "bold",
      }}
    >
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={() => setShowInstruction(false)}
      style={{
        borderRadius: "25px",
        background: "#174d82",
        padding: "10px 25px",
        fontWeight: "bold",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)"
      }}
    >
      ✅ Got it!
    </Button>
  </Modal.Footer>
</Modal>



    </div>
  );
}

UserForm.propTypes = {
  formData: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onChangeStep: PropTypes.func.isRequired,
};

export default UserForm;
